<template>
  <RegionIssueOverlay>
    <IssueForm
      :equipmentId="equipmentId"
      :inspectionId="inspectionId"
      :issueId="issueId"
      :issueNavBackRoute="issueNavBackRoute"
      :operationId="operationId"
      :organisationId="organisationId"
      :shipId="shipId"
    />
  </RegionIssueOverlay>
</template>
<script setup>
import { computed } from 'vue';
import IssueForm from '@/components/issues/issue_form.vue';
import RegionIssueOverlay from '@/components/regions/regions_issue_overlay.vue';

const props = defineProps({
  organisationId: { type: String, required: true },
  inspectionId: { type: String, required: true },
  issueId: { type: String, required: true },
  operationId: { type: String, required: false, default: null },
  shipId: { type: String, required: false, default: null },
  equipmentId: { type: String, required: false, default: null },
  heavyMobileEquipmentId: { type: String, required: false, default: null },
  issueType: { type: String, required: false, default: null },
});

// Set back route based on props
const issueNavBackRoute = computed(() => {
  switch (true) {
    case props.issueType === 'heavy_mobile_equipment':
      return 'regionsTypeHme';
    case !!props.shipId:
      return 'shipRegions';
    case !!props.equipmentId:
      return 'equipmentRegions';
    default:
      return 'regions';
  }
});
</script>
